module.exports = __webpack_public_path__ + "7353fc4277c6ac49cd93c5575635e382.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/works-with/logos/logo-suunto.png
// module id = 1790
// module chunks = 1